var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealTimePayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51C11.446 51 0 39.554 0 25.5C0 11.446 11.4098 0 25.5 0C39.5902 0 51 11.446 51 25.5C51 39.554 39.554 51 25.5 51ZM25.5 2.31818C12.7138 2.31818 2.28196 12.7138 2.28196 25.5C2.28196 38.2862 12.6776 48.6818 25.4638 48.6818C38.25 48.6818 48.6456 38.2862 48.6456 25.5C48.6456 12.7138 38.2862 2.31818 25.5 2.31818V2.31818Z",
    fill: "#292948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51 26.1157L26.5142 34.8451C26.0071 35.1349 25.3551 34.7727 25.3551 34.1931L25.2827 16.843C25.2827 16.2634 25.9347 15.865 26.4418 16.1548L41.4737 24.7755C41.9808 25.0653 41.9808 25.8259 41.4737 26.1157H41.51Z",
    fill: "#292948",
    stroke: "#292948",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2827 26.1157L10.2869 34.8451C9.77982 35.1349 9.12783 34.7727 9.12783 34.1931L9.05539 16.843C9.05539 16.2634 9.70738 15.865 10.2145 16.1548L25.2464 24.7755C25.7535 25.0653 25.7535 25.8259 25.2464 26.1157H25.2827Z",
    fill: "#292948",
    stroke: "#292948",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimePayments);
export default __webpack_public_path__ + "static/media/real-time-payments.0a12a239fe76f12c2b7390c0c730797e.svg";
export { ForwardRef as ReactComponent };